export const BasicInfo = {
  fullName: "BINIYAM M. TIRUYE",
  photoUrl:
    "https://raw.githubusercontent.com/biniyam-mt/website/main/portrait.png",
  title: "Phd Candidate,",
  department: "Computer Science",
  university: "University of Michigan",
  addressRoom: "2637 Beyster Bldg",
  addressStreet: "2260 Hayward Avenue ",
  addressZip: "Ann Arbor, MI 48109-2121",
  email: "btiruye@umich.edu",
  cvLink:
    "https://drive.google.com/file/d/1I-nttIX5uUdnX--Q9hwQgCs8gQcu6iS2/preview",
  googleScholarLink:
    "https://scholar.google.com/citations?user=REa5JCAAAAAJ&hl=en",
  linkedInLink: "https://www.linkedin.com/in/biniyam-mengist/",
  twitterLink: "",
  githubLink: "https://github.com/biniyam-mt",
  youTubeLink: "",
  instagram: "https://www.instagram.com/biniyam_mt/",
  personalBiography:
    "I am an ambitious and dedicated Computer Science graduate student specializing in privacy and security research, I am advised by Professor Todd Austin. Hailing from Ethiopia as a first-generation student, I am driven by a deep desire to bring about positive change and improve the lives of people. With a relentless pursuit of knowledge and a passion for academic excellence, I am actively establishing myself in the security research scene. My goal is to contribute innovative solutions to enhance privacy protection and strengthen security measures.",
  contentLocation:
    "https://raw.githubusercontent.com/biniyam-mt/content/main/news.json",
  edu: [
    {
      logoUrl:
        "https://raw.githubusercontent.com/biniyam-mt/website/main/umich-logo.jpg",
      institute: "University of Michigan",
      title: "Doctor of Philosophy - PhD, Computer Science",
      duration: "Aug 2021 - Jun 2026",
      grade: "Grade: 4.0",
    },
    {
      logoUrl:
        "https://raw.githubusercontent.com/biniyam-mt/website/main/aau-logo.jpg",
      institute: "Addis Ababa University",
      title: "Bachelor's degree, Software Engineering",
      duration: "Sep 2015 - Dec 2020",
      grade: "Grade: 3.82",
    },
  ],
  research: {
    researchBio:
      "I work with PETs, no not those PETs, Privacy Enhanced Technologies. Specifically, I am Interested in finding ways to embed security and privacy at the heart of the computing systems of tomorrow by leveraging advancements in both software and hardware technology. My current research focuses on building tools to automate the design and implementation of algorithms to secure them against digital side-channel attacks and to maintain the secrecy of private data.",
    researchImageUrl:
      "https://raw.githubusercontent.com/biniyam-mt/website/main/pets.png",
    publications: [
      
      {
        title: "EDL: Efficient Data-oblivious Loops",
        conference:
          "The 7th IEEE International Conference on Trust, Privacy and Security in Intelligent Systems, and Applications (TPS 2025)",
        conferenceLink:"https://www.sis.pitt.edu/lersais/conference/tps/2025/",
          description:
          "A novel approach to making data-oblivious programs more efficient using compiler optimizations.",
        year: 2025,
        authors: [
          "Biniyam Tiruye",
          "Lauren Biernacki",
          "Todd Austin",
        ],
        citations: 0,
        link: "https://drive.google.com/file/d/1T3UYsLZcyuTPkI6lk1rlBoTUdLvg2rn2/view",
        presentationLink: "",
        coverImageLink:
          "https://raw.githubusercontent.com/biniyam-mt/content/main/image/octal-poster.png",
        posterLink:
          "https://drive.google.com/file/d/1Sdav0HEoIwoxPDE4Fkz5PteKbHtmnHhw/view?usp=share_link",
      },
      {

        title: "OCTAL: DSL for data-oblivious programs",
        conference:
          "IEEE Secure Development Conference & IEEE Digital Privacy Workshop (SecDev 2024)",
        conferenceLink:"https://secdev.ieee.org/2024/home",
        description:
          " A tool for writing data-oblivious programs, estimating performance impact, and offering insight for an easy algorithm design space exploration.",
        year: 2024,
        authors: [
          "Biniyam Tiruye",
          "Tersiteab Adem",
          "Petros Mola",
          "Lauren Biernacki",
          "Todd Austin",
        ],
        citations: 0,
        link: "https://ieeexplore.ieee.org/document/10734055",
        presentationLink: "",
        coverImageLink:
          "https://raw.githubusercontent.com/biniyam-mt/content/main/image/octal-poster.png",
        posterLink:
          "https://drive.google.com/file/d/1Sdav0HEoIwoxPDE4Fkz5PteKbHtmnHhw/view?usp=share_link",
      },
      {
        title: "Exploring the Efficiency of Data-Oblivious Programs",
        conference:
          "2023 IEEE International Symposium on Performance Analysis of Systems and Software",
        conferenceLink:"https://ispass.org/ispass2023/",
        description:
          "Details the first performance characterization of data-oblivious programs and studies mechanical data-oblivious transformations applied to twenty workloads",
        year: 2023,
        authors: [
          "Lauren Biernacki",
          "Biniyam Tiruye",
          "Meron Demissie",
          "Fitsum Andargie",
          "Brandon Reagen",
          "Todd Austin",
        ],
        citations: 0,
        link: "https://ieeexplore.ieee.org/document/10158185",
        presentationLink: "",
        coverImageLink:
          "https://raw.githubusercontent.com/biniyam-mt/content/main/image/octal-poster.png",
        posterLink:
          "https://drive.google.com/file/d/1Sdav0HEoIwoxPDE4Fkz5PteKbHtmnHhw/view?usp=share_link",
      }
    ],
  },
  teaching: {
    teachingBio:
      "I am passionate about teaching and mentoring students. I have served as a Graduate Student Instructor at the University of Michigan, where I have taught various computer science courses.",
    courses: [
      {
        title: "EECS 370: Introduction to Computer Organization",
        term: "Fall 2024",
        description: "Assisted in teaching computer organization and assembly language programming."
      },
      {
        title: "EECS 280: Programming and Introductory Data Structures",
        term: "Winter 2024",
        description: "Conducted lab sessions and provided support for data structures and C++ programming."
      }
    ]
  },
  experience: [
    {
      logoUrl:
        "https://raw.githubusercontent.com/biniyam-mt/website/main/ampere-logo.png",
      company: "Ampere Computing",
      title: "CPU Architecture",
      jobType: "PhD Intern",
      duration: "Aug 2025 - Dec 2025",
      detail:
        "Conduct research in the field of computer architecture, focusing on enhancing security and privacy in computing systems. Develop tools and techniques to mitigate side-channel attacks and improve data-oblivious algorithms. Collaborate with a team of researchers to publish findings in top-tier conferences and journals.",
    },
    {
      logoUrl:
        "https://raw.githubusercontent.com/biniyam-mt/website/main/meta-logo.svg",
      company: "Meta",
      title: "Software Infrastructure",
      jobType: "PhD Intern",
      duration: "May 2025 - Aug 2025",
      detail:
        "Worked on improving the performance and scalability of software infrastructure. Collaborated with cross-functional teams to design and implement new features. Conducted research on emerging technologies and their potential impact on software development.",
    },
    {
      logoUrl:
        "https://raw.githubusercontent.com/biniyam-mt/website/main/intel-logo.png",
      company: "Intel",
      title: "Security and Privacy",
      jobType: "PhD Intern",
      duration: "May 2024 - Aug 2024",
      detail:
        "Assisted in the development of security protocols for cloud computing environments. Conducted vulnerability assessments and penetration testing. Collaborated with cross-functional teams to enhance product security.",
    },
    {
      logoUrl:
        "https://raw.githubusercontent.com/biniyam-mt/website/main/trail-of-bits-logo.png",
      company: "Trail of Bits",
      title: "Decompiler Design",
      jobType: "PhD Intern",
      duration: "Dec 2023 - Jan 2024",
      detail:
        "Contributed to the design and implementation of a new decompiler for binary analysis. Worked with a team of engineers to improve the accuracy and performance of existing tools. Participated in code reviews and provided feedback to peers.",
    },
    {
      logoUrl:
        "https://raw.githubusercontent.com/biniyam-mt/website/main/umich-logo.jpg",
      company: "University of Michigan",
      title: "Graduate Student Instructor",
      jobType: "Full-time",
      duration: "Aug 2013 - May 2025",
      detail:
        "Assisted professors in delivering course material for undergraduate computer science courses. Conducted lab sessions and provided one-on-one support to students. Graded assignments and exams, ensuring fair and consistent evaluation.",
    },
  ]
};
